module.exports = __webpack_public_path__ + "img/indeed-white.ebfc5409.png";